import { useEffect, useMemo } from 'react'

import { setEnv as setEnvStore } from '#/shared/lib/env-store'
import { PublicEnv } from '../env-types'

function getProcessEnv(): PublicEnv {
	return {
		NEXT_PUBLIC_MAIN_URL: process.env.NEXT_PUBLIC_MAIN_URL ?? '',
		NEXT_PUBLIC_API_HOST: process.env.NEXT_PUBLIC_API_HOST ?? '',
		NEXT_PUBLIC_SESSION_TIME: process.env.NEXT_PUBLIC_SESSION_TIME ?? '',
		NEXT_PUBLIC_REFETCH_INTERVAL: process.env.NEXT_PUBLIC_REFETCH_INTERVAL ?? '',
		NEXT_PUBLIC_FF_NEW_DESIGN: process.env.NEXT_PUBLIC_FF_NEW_DESIGN ?? '',
		NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN ?? '',
		NEXT_PUBLIC_WS_API_URL: process.env.NEXT_PUBLIC_WS_API_URL ?? '',
		NEXT_PUBLIC_UNLEASH_URL: process.env.NEXT_PUBLIC_UNLEASH_URL ?? '',
		NEXT_PUBLIC_UNLEASH_CLIENT_KEY: process.env.NEXT_PUBLIC_UNLEASH_CLIENT_KEY ?? '',
		NEXT_PUBLIC_UNLEASH_APP_NAME: process.env.NEXT_PUBLIC_UNLEASH_APP_NAME ?? '',
	}
}

export function useEnv(): { env: PublicEnv; loading: boolean; error: Error | null } {
	const env = useMemo(() => getProcessEnv(), [])

	useEffect(() => {
		setEnvStore(env)
	}, [env])

	return { env, loading: false, error: null }
}
